import React, { useRef } from 'react'
import { Control, Controller, FieldErrors, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CheckBox, Text, TextInput, View } from 'react-native'

import { Style, StyledText } from './Style'

type Props = {
  fontcolor: string
  questionId: string
  isMultiline: boolean
  control: Control<FieldValues>
  errors: FieldErrors<FieldValues>
  inputType: 'open' | 'condition'
}

export const OpenTypeField = ({
  fontcolor,
  questionId,
  isMultiline,
  control,
  errors,
  inputType,
}: Props) => {
  const { t } = useTranslation()
  const ref = useRef<TextInput>()
  const InputStyle = Style(fontcolor)

  return (
    <View style={InputStyle.inputContainer}>
      <Controller
        control={control}
        name={questionId}
        rules={{
          required: {
            value: true,
            message: 'This field is required.',
          },
        }}
        defaultValue=""
        render={({ onChange, onBlur, value }) =>
          inputType !== 'condition' ? (
            <TextInput
              scrollEnabled
              multiline={isMultiline}
              numberOfLines={isMultiline ? 4 : undefined}
              style={[
                InputStyle.input,
                errors[questionId] ? InputStyle.hasError : null,
              ]}
              onBlur={onBlur}
              onChangeText={onChange}
              value={value}
              ref={ref}
            />
          ) : (
            <View style={InputStyle.conditionWrapper}>
              <CheckBox
                style={InputStyle.checkBox}
                value={value}
                onValueChange={onChange}
              />
              <StyledText fontcolor={fontcolor}>
                {t('Agree to the conditions above')}
              </StyledText>
            </View>
          )
        }
      />
      {errors[questionId] && (
        <Text style={InputStyle.inputError}>{errors[questionId].message}</Text>
      )}
    </View>
  )
}
